import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { getErrorMessage } from 'src/app/shared/helpers/validationMessages';
import { PersonService } from 'src/app/shared/services/person.service';
import { EventsService } from 'src/app/shared/services/events.service';
import { productosPath, statusEnum } from 'src/app/shared/helpers/constants';
import { MatDialog } from '@angular/material';
import { DialogMessageModalComponent } from 'src/app/shared/components/dialog-message-modal/dialog-message-modal.component';
import { validateAlphanumeric } from 'src/app/shared/helpers/customValidators';
import { AppInsightsService } from 'src/app/shared/services/app-insights-service';
import { Event } from 'src/app/shared/enums/insights/event';

@Component({
  selector: 'app-cambiar-clave-usuario',
  templateUrl: './cambiar-clave-usuario.component.html',
  styleUrls: ['./cambiar-clave-usuario.component.sass'],
})
export class CambiarClaveUsuarioComponent implements OnInit {
  formPass: FormGroup;
  getErrorMessage = getErrorMessage;
  @ViewChild('form') form;
  constructor(
    private formBuilder: FormBuilder,
    private personService: PersonService,
    private eventSrv: EventsService,
    public dialog: MatDialog,
    private appInsightsService: AppInsightsService
  ) {}
  get claveOriginal() {
    return this.formPass.get('claveOriginal');
  }
  get claveNueva() {
    return this.formPass.get('claveNueva');
  }
  get claveNuevaReingresada() {
    return this.formPass.get('claveNuevaReingresada');
  }

  ngOnInit() {
    this.formPass = this.formBuilder.group({
      claveOriginal: [null, [Validators.required]],
      claveNueva: [
        null,
        [
          Validators.required,
          Validators.minLength(6),
          Validators.maxLength(15),
          validateAlphanumeric,
        ],
      ],
      claveNuevaReingresada: [
        null,
        [
          Validators.required,
          Validators.minLength(6),
          Validators.maxLength(15),
          validateAlphanumeric,
        ],
      ],
    });

    this.eventSrv.addRouteToRouterTree({
      rootPath: productosPath.path,
      path: '',
      label: 'Inicio',
    });

    this.eventSrv.addRouteToRouterTree({
      path: '',
      label: 'Cambiar Contraseña',
    });
  }

  resetForm() {
    this.formPass.reset();
    this.formPass.markAsPristine();
  }

  savePass() {
    if (!this.formPass.valid || !this.formPass.dirty) {
      return;
    }

    this.appInsightsService.trackEvent(Event.btnSavePassword);

    if (
      this.formPass.get('claveNueva').value !==
      this.formPass.get('claveNuevaReingresada').value
    ) {
      this.formPass.controls['claveNuevaReingresada'].setErrors({
        mismatchPass: true,
      });
    } else {
      this.personService.postChangePass(this.formPass.value).subscribe(
        res => {
          this.resetForm();
          this.dialog.open(DialogMessageModalComponent, {
            data: {
              title: 'DATOS GUARDADOS',
              message: 'Datos guardados correctamente.',
              type: statusEnum.success,
            },
            height: '10.3125rem',
            width: '18.125rem',
          });
        },
        err => {
          this.dialog.open(DialogMessageModalComponent, {
            data: {
              title: 'HA OCURRIDO UN PROBLEMA',
              message: 'Favor validar sus datos',
              type: statusEnum.error,
            },
            height: '10.3125rem',
            width: '18.125rem',
          });
        }
      );
    }
  }
}
